import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class URLService {
  constructor() {}

  session(embedId: string) {
    return this.getUrl(`session/${embedId}`);
  }

  blankSession(merchantShortName: string) {
    return this.getUrl(`session/blank/${merchantShortName}`);
  }

  rtpSession(token: string) {
    return this.getUrl(`session/rtp/${token}`);
  }

  customerSession() {
    return this.getUrl('customer/session');
  }

  paymentConfirmation() {
    return this.getUrl('payment/confirmation');
  }

  paymentTokenize() {
    return this.getUrl('payment/tokenize');
  }

  agreementConfirmation() {
    return this.getUrl('payment/agreement');
  }

  agreementComplete() {
    return this.getUrl('payment/agreement/complete');
  }

  agreementCompleteFee() {
    return this.getUrl('payment/agreement/complete-fee');
  }

  paymentScheduleRules() {
    return this.getUrl('payment-plans/options');
  }

  createPinVerification(email: string) {
    return this.getUrl(`pin/verification/${email}`);
  }

  confirmPinVerification(email: string, verificationId: string) {
    return this.getUrl(`pin/verification/${email}/${verificationId}`);
  }

  token() {
    return this.getUrl('token');
  }

  checkAcss() {
    return this.getUrl('acss/supported');
  }

  premiumFinanceQuote() {
    return this.getUrl('premium-finance/quote');
  }

  eft() {
    return this.getUrl('eft');
  }

  private getUrl(path: string) {
    return environment.paymentApiUrl + '/api/embed/' + path;
  }
}
